<template>
    <div class="PagePresentationSettings">
		<div v-if="!($route.name.match(/-chart/) || $route.name.match(/-editor/))">
			<div v-if="presentation && presentation.form_fields">
				<!-- :cancelable="true" -->
				<FieldForm
				:formtype="'präsentation'"
				:isnew="pid == 'new'"
				:pid="pid"
				:formfields="presentation.form_fields"
				@save="save"
				@create="create"
				@cancel="$router.push({ name: 'presentation-list' })">
				</FieldForm>
			</div>
		</div>
		<router-view></router-view>
    </div>
</template>

<script>
// Base
import Vue from 'vue';

// Componenets

// funktion

// helper
import FieldForm from '@/components/form/FieldForm';
import help_rest from '@/helpers/rest';

export default {
	name: 'PagePresentationSettings',
	components: {
		FieldForm
	},
	computed: {
		presentation(){
			return this.$store.getters.presentation;
		},
	},
	props: {
		pid: {
			type: String,
			default: 'new'
		}
	},

	created(){this.update();},
	mounted(){this.update();},
	updated(){

		if(!this.$store.getters.loadings.presentationform && this.$store.getters.presentation && this.$store.getters.presentation.id != this.pid){
			this.update();
		}
	},
	methods: {
		...help_rest,
		reset(){
			this.$store.commit('RESET_EDITUSER');
			this.$store.commit('RESET_ACTIVE_FIELD');
			this.$store.commit('RESET_PRESENTATIONID');
			this.$store.commit('UNSET_PRESENTATION');
			this.$store.commit('UNSET_ADDABLECHARTS');
			this.$store.commit('UNSET_CHARTS');
		},
		save(payload){
			var self = this;
			if(self.id && self.id == 'new') return this.create(payload);
			self.restpatch(self.$store.getters.channel.urls.presentation.replace(':id:', self.pid), payload, 'presentationform')
			.catch(errors => {
				console.error(errors);
				self.$store.commit('ADD_NOTICE', {
					'text': 'There are errors in the Form',
					'type': 'error'
				});
			});
		},
		create(payload){
			var self = this;
			if(self.id && self.id != 'new') return this.save(payload);
			self.restput(self.$store.getters.channel.urls.presentations, payload, 'presentationform')
			.catch(errors => {
				console.error(errors);
				self.$store.commit('ADD_NOTICE', {
					'text': 'There are errors in the Form',
					'type': 'error'
				});
			});
		},
		update: function(){
			const self = this;

			if(this.$store.getters.loadings.presentationform) return;
			if(this.$store.getters.loadings.presentation) return;
			if(this.$store.getters.presentation.id == this.pid) return;

			if(this.pid == 'new') {
				self.$store.commit('UNSET_PRESENTATION');
				self.$store.commit('SET_PRESENTATIONID', this.pid);
				this.restoptions(this.$store.getters.channel.urls.presentation.replace(':id:', ''), 'presentationform')
				.then(data => {

					if(data) self.$store.dispatch('SET_PRESENTATION', data);
					self.data = data;
				});
			} else {
				if(this.$store.getters.presentation && this.pid && this.$store.getters.presentation.id == this.pid) {
					self.$store.commit('SET_PRESENTATIONID', this.pid);
					return; // brauch kein update
				}

				self.$store.commit('UNSET_PRESENTATION');
				this.restget(this.$store.getters.channel.urls.presentation.replace(':id:', this.pid), 'presentationform')
				.then(data => {
					if(data) self.$store.dispatch('SET_PRESENTATION', data);
					self.$store.commit('SET_PRESENTATIONID', data.pid);
				});
			}
		}
	},
}
</script>



// WEBPACK FOOTER //
// src/pages/PagePresentationSettings.vue